import React, { FC, PropsWithChildren } from 'react';
import { get } from 'lodash';
import classNames from 'classnames';

import Icon from 'vibo-ui/Icon';
import Tooltip from 'vibo-ui/Tooltip';
import UserImage from 'components/user/images/UserImage';

import { useModal } from 'vibo-ui/Modal';
import { USER_ROLE_BADGES } from './constants';
import { getDjName } from 'services/users/helpers';

import { EventPeopleProps } from './interfaces';
import { EventUserType, Modals } from 'types/enums';
import { DjDetailsModalProps } from 'components/modals/DjDetailsModal';

import useStyles from './style';

const EventPeople: FC<PropsWithChildren<EventPeopleProps>> = ({ people = [], children }) => {
  const classes = useStyles();

  const { openModal } = useModal();

  const openDjDetailsModal = (djId: string) =>
    openModal<DjDetailsModalProps>({
      key: Modals.djDetails,
      props: {
        djId,
      },
    });

  return (
    <div className={classes.eventPeople}>
      {!!people.length
        ? people.map(user => {
            const role = get(user, 'role', EventUserType.dj) as EventUserType;
            // @ts-ignore
            const imgUrl = get(user, 'imageUrl', user?.photo?.url);
            const isDj = role === EventUserType.dj;
            const name = getDjName((user as unknown) as UserPreview);
            const shortName = isDj ? name : user.firstName;

            return (
              <Tooltip
                overlay={
                  <span className={classes.roleTooltipOverlay}>
                    <span className="role">{`${role}:`}</span>
                    <b>{name}</b>
                  </span>
                }
                mouseEnterDelay={2}
                type="primary"
                placement="bottom"
                align={{ offset: [0, 24] }}
                key={user._id}
              >
                <div
                  onClick={() => isDj && openDjDetailsModal(user._id)}
                  className={classNames('userTooltipArea', { isDj })}
                >
                  <UserImage src={imgUrl} user={user as Maybe<UserBase>} />
                  <span className="name">{shortName}</span>
                  <Icon icon={USER_ROLE_BADGES[role]} className={classNames('roleBadge', role)} />
                </div>
              </Tooltip>
            );
          })
        : null}
      {children}
    </div>
  );
};

export default EventPeople;
